export default __webpack_public_path__ + "static/dishroomLancet-74d2cc213705d11c2cebd6247faa8248.svg";